// C5 — Nettoyage des titres d'exercice pour l'affichage.
//
// Les titres sont générés par l'IA et contiennent du markdown inline (**gras**, parfois
// `code`) parce que les prompts de génération demandent explicitement « Utilise **gras**
// pour les mots-clés ». Rendus tels quels dans un <h1>, une carte ou une phrase, les
// astérisques apparaissent littéralement (ex. « Déplacement Constant avec **Time.deltaTime** »).
//
// On retire les marqueurs de gras (**…**) et de code inline (`…`). On NE touche PAS aux
// underscores (fréquents dans les identifiants Python/GDScript : __init__, _ready) ni aux
// astérisques isolés (ex. « a * b »), pour ne rien casser dans des titres qui parlent de code.
//
// Choix : on STRIPPE plutôt que de rendre le markdown, car un titre est un libellé affiché
// dans des contextes variés (titre de page, carte, texte courant, liste admin) où un rendu
// partiellement gras serait incohérent. Les composants B3 (ComebackBanner, SessionRecapModal)
// gardent volontairement leur rendu ReactMarkdown : ils ne sont pas concernés par ce défaut.
export function formatExerciseTitle(title: string | null | undefined): string {
  if (!title) return '';
  return title
    .replace(/\*\*(.+?)\*\*/g, '$1') // **gras**
    .replace(/`(.+?)`/g, '$1')       // `code`
    .trim();
}
